/**
 * Story Rules room (#856). A fence, not a voice.
 * The book you open is the book the fences hang on.
 */
export function storyRulesPath(storyId) {
  return storyId ? `/story-rules/${storyId}` : '/story-rules';
}

export const SCOPE_KINDS = [
  { value: 'book', label: 'This book' },
  { value: 'person', label: 'This person' },
  { value: 'scene', label: 'This scene' },
];
